import { Dropdown } from "primereact/dropdown";
import * as React from "react";
import "./PrwDropdownBasic.scss";

const PrwDropdownBasic = (props: any) => {

  let { options, placeholder, ...restProps } = props;

  // Default values
  options["showClear"] = options["showClear"] ?? false;
  options["filter"] = options["filter"] || false;
  options["optionLabel "] = options["optionLabel"] || "label";
  options["optionValue "] = options["optionValue"] || "value";
  options["editable "] = options["editable"] || false;
  options["dropdownOptions"] = options["dropdownOptions"] || [];

  return (
    <div className="prw-dropdown-basic">
      <Dropdown
        className={`p-inputtext-sm ${props?.rawErrors?.length > 0 ? 'p-invalid': null}`}
        value={restProps.value}
        options={options.dropdownOptions}
        optionLabel={options.optionLabel}
        optionValue={options.optionValue}
        placeholder={""}
        filter={options.filter}
        showClear={options.showClear}
        filterBy={options.optionLabel}
        editable={options.editable}
        onChange={(e: any) => {
          restProps.onChange(e.value);
        }}
      />
    </div>
  );
};

export default PrwDropdownBasic;
